import apiSearch from '../../api/apiSearch'

const state = {
    searchResults: [],
    currentPage: null,
    lastPage: null,
    firstPage: 1,
    totalLots: null,
    activeLotKey: null,
    isLoading: false,
    isVisited: []
}

const getters = {
    getSearchResults: function (state) {
        return state.searchResults
    },
    getSearchResultsCurrentPage: function (state) {
        return state.currentPage
    },
    isSearchResultsLastPage: function (state) {
        return state.lastPage === state.currentPage
    },
    getSearchResultsFirstPage: (state) => {
        return state.firstPage
    },
    getSearchResultsLastPage: (state) => {
        return state.lastPage
    },
    getTotalLots: function (state) {
        return state.totalLots
    },
    getSearchResultsLoadingStatus: (state) => {
        return state.isLoading
    },
    checkIfLotIsVisited: (state) => (lotId) => {
        return state.isVisited.includes(lotId)
    }
}

const mutations = {
    changeResults: function (state, newResults) {
        state.searchResults = newResults
    },
    setLastPage: function (state, lastPage) {
        state.lastPage = lastPage
    },
    setTotalLots: function (state, totalLots) {
        state.totalLots = totalLots
    },
    setCurrentPage: function (state, currentPage) {
        state.currentPage = currentPage
    },
    updateSearchResults: function (state, newResults) {
        state.searchResults = newResults
    },
    setActiveLotBids: (state, value) => {
        state.searchResults[state.activeLotKey].bids = value
    },
    setActiveLotKey: (state, value) => {
        state.activeLotKey = value
    },
    updateSearchResultsLoadingStatus: (state, value) => {
        state.isLoading = value
    },
    pushLotIdToIsVisited: (state, value) => {
        state.isVisited.push(value)
    }
}

const actions = {
    fetchResults: function (context) {
        context.commit('updateSearchResultsLoadingStatus', true)
        context.dispatch('setStatusLoading')
        apiSearch
            .searchRequest(context.getters.getQuery)
            .then((response) => {
                context.commit('updateSearchResultsLoadingStatus', false)
                context.commit('setTotalLots', response.data.total)
                context.commit('changeResults', response.data.data)
                context.commit('setCurrentPage', response.data.current_page)
                context.commit('setLastPage', response.data.last_page)
                context.dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    loadMoreResults:({ dispatch, commit, getters }, newPage) => {
        dispatch('setSearchQueryPageNumber', newPage)
        apiSearch
            .searchRequest(getters.getQuery)
            .then((response) => {
                commit('updateSearchResults', response.data.data)
                commit('setCurrentPage', response.data.current_page)
            })
            .catch(error => console.log(error))
    },
    changeSearchResultActiveLotKey: ({ commit }, value) => {
        commit('setActiveLotKey', value)
    },
    changeSearchResultActiveLotBids: ({ commit }, value) => {
        commit('setActiveLotBids', value)
    },
    setSearchResultsLoadingStatus: ({ commit }, value) => {
        commit('updateSearchResultsLoadingStatus', value)
    },
    setAdvanceSearchResultTotalLotsNumber: ({commit}, value) => {
        commit('setTotalLots', value)
    },
    setLotToIsVisited: ({ commit }, value) => {
        commit('pushLotIdToIsVisited', value)
    }
}


export default { state, getters, mutations, actions }




// WEBPACK FOOTER //
// ./src/store/modules/searchResults.js